import styled from 'styled-components';
import theme from '../../../../styles/theme';
import NaviText from '../../common/NaviText';
import Button from '../../../common/Button';
import moment from 'moment';

import { useGetInspectHistSel, useSetInspect } from '../../../../interface/inspect';
import React, { useCallback, useState, useEffect } from 'react';

import { Row } from '../../../../styles/common';
import { FormControl, Select, InputLabel, TextField, MenuItem } from '@mui/material';
import { useGetCodeList } from '../../../../interface/common';
import { useQuery } from 'react-query';
import CommonDataGrid from '../../../common/CommonDataGrid';
import MsgModal from '../../../common/modal/MsgModal';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        // display: flex;
        // align-items: center;//stretch;
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
        // background: ${theme.color.black[40]};
        // border: 1px solid red;
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }
    // .close {
    //     position: absolute;
    //     top: 0px;
    //     right: 0;
    // }
`;
const columns = [
    { field: 'tno', headerName: '자산번호', flex: 0.5 },
    { field: 'status_nm', headerName: '상태', flex: 0.5 },
    { field: 'model_nm', headerName: '모델명', flex: 0.5 },
    { field: 'contents', headerName: '내용', flex: 0.5 },
    { field: 'descr', headerName: '비고', flex: 0.5 },
    { field: 'reg_dt', headerName: '등록일',valueGetter: (param) => moment(param.reg_dt).format('YYYY/MM/DD') ,flex: 0.5 },
]
const InspectItem = ({item, onClose}) => {

    return !item ? <InputForm onClose={onClose} /> : <InputForm pItem={item} onClose={onClose} />

}

const InputForm = ({pItem,onClose}) => {

    const [sendItem, setSendItem] = useState(pItem?pItem:{});

    const { mutate, error } = useSetInspect();
    const {data : ispTpList} = useGetCodeList('isp_tp');
    const {data : ispKdList} = useGetCodeList('isp_kd');
    const {data: list, isLoading } = useGetInspectHistSel(pItem && {sno:pItem.sno});
    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const [toggle,setToggle] = useState(false);
    const [errorMsg, setErrorMsg] = useState();

    const handleValueChange = (id, val) => {
        sendItem[id]=val
    }

    const handleRegClick = useCallback(() => {
        sendItem['mode'] = 'POST';
        sendItem['isp_st'] = 'R';
        sendItem['reg_id'] = user.uid;
        mutate(
            sendItem,
            {
                onSuccess:()=>{
                    setToggle(true);
                    setErrorMsg('등록 하였습니다.');
                },
                onError:(e)=>{
                    setToggle(true);
                    setErrorMsg('등록에 실패하였습니다.'+e);
                }
            }
            );
    },[mutate]);

    useEffect(()=>{
        if(error && error !== null && error.response && error.response.data){
            setErrorMsg(error.response.data.message)
        }
    },[error])

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'자산조사'},{text:'자산조사 상세'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div 
                style={{
                    flexGrow:1,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start'
                }}
            >
                <Row col={5} style={{marginTop:'8px'}}>
                    <TextField
                        id='isp_nm'
                        label='조사명'
                        size='small'
                        defaultValue={pItem && pItem.isp_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='ispTp-label'>조사유형</InputLabel>
                        <Select label="조사유형" labelId='ispTp-label' size='small' defaultValue={pItem && pItem.isp_tp}>
                            {ispTpList && ispTpList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('isp_tp',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='ispKd-label'>조사대상</InputLabel>
                        <Select label="조사대상" labelId='ispKd-label' size='small' defaultValue={pItem && pItem.isp_kd}>
                            {ispKdList && ispKdList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('isp_kd',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <TextField 
                        id='sdate'
                        label='조사기간(시작)' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small' 
                        defaultValue={pItem && moment(pItem.sdate).format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='edate'
                        label='조사기간(종료)' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small'
                        defaultValue={pItem && moment(pItem.edate,'YYYYMMDD').format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='reg_nm'
                        label='등록자' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        InputProps={{
                            readOnly: true,
                          }}
                        type='text' 
                        size='small' 
                        defaultValue={pItem ? pItem.reg_nm : user.user_nm}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='contents' 
                        label='조사내용' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        defaultValue={pItem && pItem.contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr' 
                        label='비고' 
                        fullWidth 
                        multiline 
                        rows={4} 
                        size='small' 
                        defaultValue={pItem && pItem.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
            </div>
            <CommonDataGrid
                    isLoading={isLoading}
                    list={list ? list[0] : [] }
                    columns={columns}
                    // onRowClick={(e)=>{setTarget(e.row);setRegOpen(true)}}
                />
            {
                <MsgModal open={toggle}>
                    <div onClick={()=>setToggle(false)}>
                        {errorMsg}
                    </div>
                </MsgModal>
            }
            <div>
                <Button onClick={handleRegClick}>등록</Button>
            </div>
        </MainWrap>
    )
}

export default InspectItem;